import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from './images/logo.png'
import _imports_1 from './images/name.svg'
import _imports_2 from './images/num.png'


const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "m",
  src: _imports_0,
  width: "409",
  height: "101"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "fonts" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    width: "550"
  })
], -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "companys" }
const _hoisted_9 = { class: "btns" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "about-company" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  width: "41"
}, null, -1)
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1)
const _hoisted_16 = { class: "p" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1)
const _hoisted_18 = { class: "p" }
const _hoisted_19 = {
  key: 2,
  class: "imgs"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, null, -1)
const _hoisted_24 = { class: "img" }
const _hoisted_25 = ["src"]

export function render(_ctx, _cache) {
  const _component_MiniTitle = _resolveComponent("MiniTitle")
  const _component_Aura = _resolveComponent("Aura")
  const _component_item = _resolveComponent("item")

  return (_openBlock(), _createBlock(_component_item, { title: "兰州国际港务区投资开发有限公司" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_MiniTitle, { title: "陆港介绍" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Aura)
            ]),
            _hoisted_6
          ]),
          _createElementVNode("div", {
            class: "description",
            innerHTML: _ctx.companyInfo.introductionContent
          }, null, 8, _hoisted_7)
        ]),
        _createVNode(_component_MiniTitle, { title: "平台及公司" }),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.index
                }, [
                  _createElementVNode("span", {
                    class: _normalizeClass({active: _ctx.activeCompany === item.name}),
                    onClick: $event => (_ctx.activeCompany=item.name)
                  }, _toDisplayString(item.name), 11, _hoisted_10)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_ctx.data[_ctx.activeCompany])
              ? (_openBlock(), _createElementBlock("h2", _hoisted_12, [
                  _createElementVNode("i", null, [
                    _createTextVNode(_toDisplayString(_ctx.data[_ctx.activeCompany].index) + " ", 1),
                    _hoisted_13
                  ]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.data[_ctx.activeCompany].name), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.data[_ctx.activeCompany])
              ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                  _createElementVNode("li", null, [
                    _hoisted_15,
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.data[_ctx.activeCompany].value1), 1)
                  ]),
                  _createElementVNode("li", null, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.data[_ctx.activeCompany].value2), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.data[_ctx.activeCompany] && _ctx.data[_ctx.activeCompany].image)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data[_ctx.activeCompany].image, (item) => {
                      return (_openBlock(), _createElementBlock("li", null, [
                        _hoisted_20,
                        _hoisted_21,
                        _hoisted_22,
                        _hoisted_23,
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("img", { src: item }, null, 8, _hoisted_25)
                        ])
                      ]))
                    }), 256))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}